module.exports = require('react/lib/ReactTransitionGroup');


//////////////////
// WEBPACK FOOTER
// ./~/react-addons-transition-group/index.js
// module id = 276
// module chunks = 0